import { useCallback, useMemo, useState } from 'react';

import { useLocationsZipcodesListQuery } from 'src/common/external/bambi-api/bambiApi';
import { ItemSelector } from 'src/common/ItemSelector/ItemSelector';

export function ZipCodesFilter({
  selectedZipCodes,
  onZipCodeChange,
}: {
  selectedZipCodes: string[];
  onZipCodeChange: (zipCodes: string[]) => void;
}) {
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  const {
    zipCodeItems,
    isLoading: zipCodesLoading,
    isFetching: zipCodesFetching,
  } = useLocationsZipcodesListQuery(
    {
      zipcode: debouncedSearchTerm,
    },
    {
      selectFromResult: (result) => {
        const zipCodeItems =
          result.data?.results.map((zipCode) => ({
            id: zipCode.zipcode,
          })) || [];
        return {
          ...result,
          zipCodeItems,
        };
      },
    }
  );

  const selectedZipCodesItems = useMemo(
    () => selectedZipCodes.map((zipCode) => ({ id: zipCode })),
    [selectedZipCodes]
  );

  const handleZipCodeChange = useCallback(
    (zipCodes: { id: string }[]) => {
      onZipCodeChange(zipCodes.map((zipCode) => zipCode.id));
    },
    [onZipCodeChange]
  );

  return (
    <ItemSelector
      items={zipCodeItems}
      selectedItems={selectedZipCodesItems}
      loading={zipCodesLoading}
      searching={zipCodesFetching}
      onSelectionChange={handleZipCodeChange}
      onSearchChange={setDebouncedSearchTerm}
      searchPlaceholder="Search zip codes"
      dataTestId="zip-codes-filter-search"
      noItemsText="No zip codes found."
    />
  );
}
